import React from "react";
import "./EditProduct.css";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router-dom";
import SimpleDropdown from "../SimpleDropdown";
import Brands from "../../Data/Brands";
import Categories from "../../Data/Categories";
import axios from "axios";
import * as backendModule from "../../modules/backendModule";
import Spinner from "../Spinner";
import { useSearchParams } from "react-router-dom";

const EditProduct = () => {
    const [isAvailable, setIsAvailable] = React.useState(null);
    const [brend, setBrend] = React.useState(null);
    const [category, setCategory] = React.useState(null);
    const [image, setImage] = React.useState(null);
    const [image2, setImage2] = React.useState(null);
    const [error, setError] = React.useState(null);
    const [spinner, setSpinner] = React.useState(null);
    const [dataSpinner, setDataSpinner] = React.useState(true);
    const [message, setMessage] = React.useState(null);
    const [data, setData] = React.useState(null);
    const nameRef = React.useRef(null);
    const priceRef = React.useRef(null);
    const modelRef = React.useRef(null);
    const descriptionRef = React.useRef(null);

    const [searchParams] = useSearchParams();
    const editIDproduct = searchParams.get("id");

    const getProduct = () => {
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/getProductByID`,
            data: {
                ID: editIDproduct
            },
            ...backendModule.axiosConfig,
        }).then(res => {
            if (res.data.status === "ok") {
                setData(res.data?.data);
                setError(null);
            } else {
                setError('Došlo je do serverske greške');
                setMessage(null);
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
            setMessage(null);
        }).finally(() => {
            setDataSpinner(false);
        });
    }

    const handleImageChange = (e) => {
        setImage(e.target.files[0]);
    }
    const handleImageChange2 = (e) => {
        setImage2(e.target.files[0]);
    }

    const editProduct = () => {
        if (
            nameRef.current.value !== null &&
            priceRef.current.value !== null &&
            modelRef.current.value !== null &&
            descriptionRef.current.value !== null
        ) {
            setSpinner(true);
        } else {
            return setError('Nedovoljno podataka!');
        }

        const data = new FormData();
        data.append('ID', editIDproduct);
        data.append('Name', nameRef.current.value);
        data.append('Model', modelRef.current.value);
        data.append('Price', priceRef.current.value);
        data.append('Description', descriptionRef.current.value);
        if (isAvailable !== null) {data.append('Available', isAvailable.value);}
        if (category) {data.append('Category', category.name);}
        if (category) {data.append('CategoryID', category.value);}
        if (brend) {data.append('Brand', brend.name);}
        if(brend) {data.append('BrandID', brend.value);}

        if (image) {
            data.append('image', image);
        }

        if (image2) {
            data.append('image2', image2);
        }

        axios({
            method: "POST",
            url: `${backendModule.backendURL}/products/editProduct`,
            data: data,
            ...backendModule.axiosConfig,
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            if (res.data.status === "ok") {
                setMessage('Uspješno ste uredili proizvod.');
                setError(null);
            } else {
                setError('Došlo je do serverske greške');
                setMessage(null);
            }
        }).catch(() => {
            setError('Došlo je do serverske greške');
            setMessage(null);
        }).finally(() => {
            setSpinner(false);
        });
    }

    React.useEffect(() => {
        getProduct();
    }, [editIDproduct]);

    return (
        <div className="addNew">
            <Sidebar />
            {!dataSpinner && <div className="addNew__container">
                <div className="addNew__container__modal">
                    <div className="addNew__container__modal__item">
                        <label>Naziv proizvoda</label>
                        <input ref={nameRef} type="text" defaultValue={data?.Name} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Cijena</label>
                        <input ref={priceRef} type="text" defaultValue={data?.Price} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Model</label>
                        <input ref={modelRef} type="text" defaultValue={data?.Model} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Dostupno</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading={data?.Available ? 'DA' : 'NE'} data={[{ name: 'Da', value: true }, { name: 'Ne', value: false }]} setSelected={setIsAvailable} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Brend</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading={data?.Brand} data={Brands.map((item) => { return { name: item.Name, value: item.ID } })} setSelected={setBrend} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Kategorija</label>
                        <SimpleDropdown headTextStyle={{ color: '#1A1A1A' }} headStyle={{ height: '30px', background: 'white', border: '1px solid black', borderRadius: '0px' }} heading={data?.Category} data={Categories.map((item) => { return { name: item.Name, value: item.ID } })} setSelected={setCategory} />

                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Slika 1</label>
                        <input accept="image/*" type='file' name="image" onChange={handleImageChange} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Slika 2</label>
                        <input accept="image/*" type='file' name="image" onChange={handleImageChange2} />
                    </div>
                    <div className="addNew__container__modal__item">
                        <label>Opis</label>
                        <textarea ref={descriptionRef} defaultValue={data?.Description}></textarea>
                    </div>
                </div>
                <div onClick={() => editProduct()} className="addNew__container__button">
                    {!spinner ? <p>Sačuvaj</p> : <Spinner color='white' style={{ width: '24px', height: '24px', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} />}
                </div>
                {message && <p style={{ color: "green", fontSize: "18px", marginTop: "10px" }}>{message}</p>}
                {error && <p style={{ color: "#b31414", fontSize: "18px", marginTop: "10px" }}>{error}</p>}
            </div>}
            {dataSpinner && <Spinner color="#1A1A1A" style={{width: "64px", height: "50px", marginLeft: '20px', marginRight: 'auto', display: 'block', marginTop: "20px"}} />}
        </div>
    );
};

export default EditProduct;
